import { render, staticRenderFns } from "./DSPrintIcon.vue?vue&type=template&id=5407ccef&scoped=true&"
import script from "./DSPrintIcon.vue?vue&type=script&lang=js&"
export * from "./DSPrintIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5407ccef",
  null
  
)

export default component.exports